const micrositeBaseUrl = 'https://schools.guildeducation.com';
const micrositePathsByInstitutionUuid = {
  '6b164e12-858b-442c-944f-100ea3546b95': '2u-cambridge', // 2U - University of Cambridge Online Executive Education
  '9e46ef6f-5204-44d5-aa0f-5ac16d77f393': '2u-gwu', // 2U - George Washington University Online Executive Education
  'f40c75f4-394e-4863-9cbb-7c8e86b0541d': '2u-harvard', // 2U - Harvard University Online Executive Education
  'f183de29-33f3-4003-807e-89fe22c83ccb': '2u-lse', // 2U - London School of Economics and Political Science Online Executive Education
  'f38287d8-b67c-4c47-94e5-2af9b3c37818': '2u-mit', // 2U - Massachusetts Institute of Technology Online Executive Education
  '81aa5a2f-55d0-40fe-8ef1-b1f9c394c915': '2u-morehouse', // 2U - Morehouse College
  'bffcf872-94f3-4f99-b4ed-dec284d54ae3': '2u-msu', // Michigan State University Boot Camps
  '56011833-407b-4cf4-aef0-4893697869dc': '2u-northwestern', // 2U - Northwestern University Online Executive Education
  'e882b26f-fb5a-4f72-92ac-e70854ea2e3b': '2u-oxford', // 2U - University of Oxford Online Executive Education
  '367a7881-f94e-4c27-9270-ebfe9a769a68': '2u-rice', // 2U - Rice University Online Executive Education
  '5e966193-49e3-4c56-8690-a8f50f1af020': '2u-rutgers', // 2U - Rutgers University Bootcamps
  '74685283-4308-4fe9-89bd-66fe1ad8a17c': '2u-syracuse', // 2U - Syracuse University Online Executive Education
  '44ff44e3-3d49-4ae2-944e-3e230f1b3de9': '2u-tec-monterrey', // 2U - Tecnológico de Monterrey Online Executive Education
  'cb92513a-4e44-469e-943e-522f089563f9': '2u-uc-berkeley', // 2U - University of California, Berkeley Online Executive Education
  '75335197-2c66-445a-9acc-4c3b772d6295': '2u-uc-davis', // 2U - University of California, Davis Online Executive Education
  '7cb9c189-94d3-4dee-90b6-1aede9212e6b': '2u-uc-irvine', // 2U - UC Irvine Bootcamps
  '50673e6a-2d46-44e7-9202-335f598b1186': '2u-umn', // 2U - UMN Boot Camps
  'b5d19612-c83c-46c2-9c47-dc3539b79f1a': '2u-ut-austin', // 2U - UT Austin Bootcamps
  '5f31fd1e-64f4-4e2d-848d-9024a5c5af79': '2u-yale', // 2U - Yale University Online Executive Education
  '0cce4041-8056-449e-bfe3-f56f4e9e449a': 'ancora', // Ancora
  '330d5a73-8811-487d-b850-32a110ad5ee2': 'arizona', // University of Arizona
  'f677f57f-5070-4edd-942b-a5140b96e4d4': 'bellevue', // Bellevue University
  '1184458a-8f3b-4e3a-a2e0-e8db993d979e': 'chamberlain', // Chamberlain
  '793f9949-1c46-4c22-b73c-89549badc860': 'collegestart', // Guild Education
  '7bd6a288-b128-4756-b00d-d4e7c709c07e': 'collegestart', // Guild Education
  '1890f34c-1228-44d2-a4c2-f0a5fc9af9ce': 'csu', // Colorado State University College of Business
  'c52308fb-4528-47d6-a1d4-40a406ab4815': 'denver', // University of Denver
  '05984e96-f53f-4cd4-a48c-7e713199874c': 'excelsior', // Excelsior College
  '3ce34f6c-6fb2-4d39-b029-f8f40717df62': 'ecornell', // eCornell
  'd489493d-e4d3-43da-822b-b0888e728d2b': 'florida', // University of Florida
  'b6e0838d-5741-4f5c-bb92-664d9f8140c0': 'jwu', // Johnson & Wales University
  'd4d8307a-b2d6-4cbf-9122-b65dbff95a58': 'lsu-alexandria', // LSU Alexandria
  '5724d78d-f940-49a7-ac8d-b3c3d101f9e5': 'lsu-certificates', // Open Classroom
  'f188bd0a-0d0e-4e38-9fbf-7468aa5cab17': 'lsu-online', // LSU Online
  '792dcd7c-618d-401f-8322-06d633439a97': 'pathstream', // Pathstream
  'fcb4b352-f715-4fec-bcf6-b215b7ff1059': 'paulquinncollege', // Paul Quinn College
  'c83fde59-bdc7-44da-8485-006bf0cd2633': 'pfcareer', // Penn Foster Career School
  'bbe2e9f8-d122-4c36-bb0d-3a5afa788e62': 'pfhs', // Penn Foster High School
  '927b7a7e-36f7-488d-b066-6ed170d1b47d': 'pg', // Purdue University Global
  '6394062d-9301-4db4-a773-dc3ba22f86f1': 'north-carolina-at', // North Carolina A&T State
  'ca1575d7-620d-4815-ae0d-5a93032aa35f': 'ohio-university', // Ohio University
  '8c71daaa-0143-477f-9ebc-7822ba3a8b0c': 'osu', // Oregon State University
  '2cee4b47-caec-4299-b5cd-10d5f4c64d10': 'openclassrooms', // Open Classroom
  '2d9d6477-89b5-458f-81b1-a5cc32f4b46a': 'outlier', // Outlier.org
  '8d8983ae-a0e3-48f5-ab46-db985e75fdbe': 'rio-salado', // Rio Salado College
  '2d622c10-8bdb-4957-a840-ab2674ae31bd': 'spelman', // eSpelman
  '20fd9dfd-a73f-4988-b43f-3b13c22eb0aa': 'snhu', // Southern New Hampshire University
  '2141da5c-9011-4af5-b481-a695af3863c0': 'study', // Study.com
  '3751e896-5051-4770-be96-20d6be98df64': 'chegg-skills', // chegg-skills,
  '26a9440a-0a3e-435c-b787-48ec911c52a7': 'ucf', // University of Central Florida
  'e3a7bfff-0ae1-4ff1-b62b-c030daba3d1b': 'umgc', // University of Maryland Global Campus
  '7cbb5159-348a-4bb3-9f71-bb9854e77425': 'umassglobal', // UMass Global
  '56bcc1df-27a6-441d-9b00-f47326d0b240': 'umassglobal', // UMass Global RN to BSN
  '91148843-243b-4c47-9cd1-5de9c3e898d9': 'valencia', // Valencia College
  'cbcbc628-eb37-4ebd-9dad-d934cc11e555': 'valenciacontinuinged', // Valencia College Continuing Education
  '32718ec3-e476-4709-a561-c064cc297979': 'engen', // Engen
  '6b21e5db-aa59-4773-8f94-4ecd0a1e4287': 'wilmington', // Wilmington University
  'c21d97d0-018e-41d1-8a67-6a43407dbf01': 'umassglobal-mypath', // UMass Global RN to UMass Global MyPath
  '6e0191cf-d3e8-44e1-8703-11e5325c8a77': 'kenzie', // Kenzie Academy
  '8415afc6-a51c-4164-a952-6518dea27ac4': 'umc', // University of Minnesota Crookston
  'f2297827-c708-4f4c-ba36-9e80633e14c8': 'medcerts', // MedCerts
  'ed8cb8a4-1ec7-45e3-a976-d1c07f3affde': 'fullerton', // Fullerton College
  'caa3f615-6569-477c-a2b3-80861d9dee04': 'mercy-college-ohio', // Mercy College of Ohio
  '0f75a69c-0134-4e1b-b7f0-f072c702f46b': 'regis', // Regis University
  '552f79c8-a64a-4520-b6da-87e7a309232e': 'csu-fullerton', // Calinfornia State University Fullerton
  '011de4ce-d78e-4fa2-9b50-2e0f69a67fe0': 'ivy-tech', // ivy tech college
  '41fbb098-c1be-41c6-b2ea-1feaacd90618': 'herzing', // Herzing University
  '3e029c4a-c524-41df-a71c-0263398bf103': 'bsmcon', // Bon Secours Memorial College of Nursing
  '7ec940f4-6d90-4857-934f-49c38379be57': 'schs', // Southside College of Health Sciences
  'fc67286b-3002-4c69-add1-cebdc2e47645': 'acfs', // American College of Financial Services
  'c9573675-9d75-4a2c-8eaf-55865cf59b02': 'bs-somi', // Bon Secours St. Mary's Hospital School of Medical Imaging
  '4ab960c7-ccb8-4257-abfa-894f6936455d': 'adventhealth-university', // AdventHealth University
  'b0a8aec0-1b89-49bb-b06a-1d5c2403ef6d': 'smart-horizons-cohs', // Smart Horizons
  '7e091a5d-052c-4112-be3d-3dfb9372d345': 'busuu-step', // Busuu
  '23d57449-281f-490d-a8b8-9fbdb9972c24': 'careerstep', // CareerStep
  'e9980f4f-a914-44de-bea3-1c1277e621d8': 'rio-salado-college-start', // Rio Salado College
  '7156b1b5-4769-4e74-ba46-96db66b1cc18': 'pathstream-texas-am-step', // Pathstream-texas-am
  'f00e3da4-e164-457d-bef3-dcf77e9918b3': 'pathstream-florida-am-step', // Pathstream-florida-am
  '6655578d-981f-44ab-917d-a5162f6d555b': 'pathstream-nyu-step', // Pathstream-nyu
  'c78cdce5-7162-4085-b382-4354efcf8c3e': 'pathstream-emory-step', // Pathstream-emory
  'd8e7ca94-0ebc-4955-a4db-ac9a52a37247': 'pathstream-harvard-step', // Pathstream-harvard
  '888883af-4926-466a-8c71-0d9bed30517e': 'springboard', // Springboard
  '64d561c6-e58e-4252-b341-a548ac8ef1a7': 'saint-anthony-step', // St Anthony College of Nursing
  'a24f2ffc-cc8f-4c29-8237-c303edaa3798': 'saint-francis-step', // Saint Francis Medical Center College of Nursing
  '6e9e3d7c-5904-4b67-9f7e-7683b9c8f990': 'new-readers-press', // ProLiteracy
  '8fad6007-5b29-4dae-b0c4-149a4e41cd47': 'sisucare-education', // SisuCare
  '17964a7a-b5c9-4301-9e9e-1d8eb68f61ae': 'uofark-online', // University of Arkansas Online
  'ba00bdbe-5ac3-4607-b296-66442708d4f2': 'uofark-professional', // University of Arkansas Professional
};

// Programs with unique microsites ( 'Program UUID': 'URL' )
const micrositePathsByProgramUuid = {
  'afd46c15-4bb0-4f92-8e7d-caf6fe8240c1': 'fmlp', // University of Denver Frontline Management Leadership Program
  '6bfe6dde-d7ca-4bc5-979b-8ad5f41c3a91':
    'golden-gate-university-degrees-powered-by-outlierorg-step', // Golden Gate University Degrees+ powered by Outlier
  'c4165050-b696-4e23-93a5-f013f89cdb23': 'simplilearn-step', // Simplilearn
  'ad470e0f-8343-446c-b041-2048bc541300': 'ed2go', // ed2go
};

const getMicrositeUrl = (
  institutionUuid?: string,
  isReEnrollment?: boolean,
  programUuid?: string
) => {
  const micrositePage = isReEnrollment ? '2' : '1';

  const programPath =
    programUuid && micrositePathsByProgramUuid[programUuid]
      ? `${micrositePathsByProgramUuid[programUuid]}-${micrositePage}`
      : '';

  const institutionPath =
    institutionUuid && micrositePathsByInstitutionUuid[institutionUuid]
      ? `${micrositePathsByInstitutionUuid[institutionUuid]}-${micrositePage}`
      : '';

  if (!programPath && !institutionPath) {
    return micrositeBaseUrl;
  } else if (programPath) {
    return `${micrositeBaseUrl}/${programPath}`;
  } else {
    return `${micrositeBaseUrl}/${institutionPath}`;
  }
};

export const openNextStepsMicrositeForInstitution = (
  institutionUuid?: string,
  isReEnrollment?: boolean,
  programUuid?: string
) => {
  const micrositeUrl = getMicrositeUrl(institutionUuid, isReEnrollment, programUuid);
  window.open(micrositeUrl, '_self');
};
